// @third-party-packages
import { useState, useEffect, useCallback } from 'react';

import { traverse } from '../constants';

export const defaultTableFilterInitState: IBaseTableFilter = {
  isOpen: false,
  isDisabled: false,
  activeFilters: {},
};
export interface IBaseTableFilter {
  isOpen: boolean;
  isDisabled: boolean;
  activeFilters: any;
}
export interface ITableFilter {
  isOpen: boolean;
  isDisabled: boolean;
  filters: any;
  activeFilters: any;
}

export interface ITableFilterInitState extends ITableFilter, IBaseTableFilter {}

export const useTableFilter = (initialState: ITableFilter) => {
  const [state, setState] = useState<ITableFilterInitState>({
    ...initialState,
  });

  useEffect(() => {
    setState({
      ...state,
      filters: {},
      activeFilters: {},
    });
  }, [window.location.pathname]);

  // if there are no more activeFilters
  useEffect(() => {
    if (Object.keys(state.activeFilters).length === 0) {
      setState({
        ...state,
        isDisabled: false,
      });
    }
  }, [state.activeFilters]);

  const toggleIsOpen = useCallback(() => {
    let nOpen = state.isOpen;

    setState({
      ...state,
      isOpen: !nOpen,
    });
  }, [state, state.isOpen]);

  const toggleIsDisabled = useCallback(() => {
    let nDisabled = state.isDisabled;
    setState({
      ...state,
      isDisabled: !nDisabled,
    });
  }, [state, state.isDisabled]);

  const update = useCallback(
    (prop, value) => {
      setState({
        ...state,
        filters: {
          ...state.filters,
          [prop]: value,
        },
      });
    },
    [state, state.filters]
  );

  const clear = useCallback((filterName) => {
    // console.log('clearning single filter', filterName);
  }, []);

  const clearAll = useCallback(() => {
    const cleared = traverse(state.filters, '');

    setState({
      ...state,
      isOpen: false,
      filters: {
        ...cleared,
      },
      activeFilters: {},
    });
  }, [state.activeFilters, state.filters]);

  const clearSavedFilter = useCallback(
    (filterName: string) => {
      let nState = state;
      if (filterName === 'pkgName') {
        delete nState.activeFilters.pkgId;
        nState.filters.pkgId = '';
      }
      delete nState.activeFilters[filterName];
      nState.filters[filterName] = '';

      setState({
        ...nState,
        activeFilters: {
          ...nState.activeFilters,
        },
      });
      refreshUrl();
    },
    [state.activeFilters, state.filters, state.isOpen]
  );

  const refreshUrl = () => {
    let params = [];
    let activeFilters = {};
    for (const [key, value] of Object.entries(state.filters)) {
      if (value) {
        Object.assign(activeFilters, { [key]: value });
        params.push(`${key}=${value}`);
      }
    }
    const searchParams: URLSearchParams = new URLSearchParams(
      window.location.search
    );

    let columnKeys = ['sortColumn', 'sortAscending'];

    for (const [key, value] of searchParams.entries()) {
      if (columnKeys.includes(key)) {
        params.push(`${key}=${encodeURIComponent(value)}`);
      }
    }

    const refresh = window.location.pathname + `?${params.join('&')}`;

    window.history.pushState({ path: refresh }, '', refresh);

    return activeFilters;
  };

  const save = useCallback(() => {
    let activeFilters = refreshUrl();

    setState({
      ...state,
      isOpen: false,
      activeFilters: {
        ...activeFilters,
      },
    });
  }, [state.filters, state.activeFilters]);

  return {
    isOpen: state.isOpen,
    isDisabled: state.isDisabled,
    filters: state.filters,
    activeFilters: state.activeFilters,
    save: save,
    update: update,
    clear: clear,
    clearSavedFilter: clearSavedFilter,
    clearAll: clearAll,
    toggleOpen: toggleIsOpen,
    toggleDisable: toggleIsDisabled,
  };
};
